var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRpIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "rp-icon_svg__Layer_2",
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 334.62 276.51"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rp-icon_svg__cls-1,.rp-icon_svg__cls-2{fill:#2463eb;stroke-width:0;image-rendering:auto}.rp-icon_svg__cls-2{fill:#000}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "rp-icon_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-2",
  y: 115.75,
  width: 40.37,
  height: 46.3,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-1",
  x: 294.25,
  y: 115.75,
  width: 40.37,
  height: 46.3,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-2",
  x: 58.85,
  y: 92.61,
  width: 40.37,
  height: 92.6,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-1",
  x: 235.4,
  y: 92.61,
  width: 40.37,
  height: 92.6,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-2",
  x: 117.69,
  width: 40.38,
  height: 185.21,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-2",
  x: 176.3,
  width: 40.38,
  height: 46.3,
  rx: 20.19,
  ry: 20.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "rp-icon_svg__cls-1",
  x: 176.3,
  y: 91.3,
  width: 40.38,
  height: 185.21,
  rx: 20.19,
  ry: 20.19
}))));
export default SvgRpIcon;